import React from 'react';
import PropTypes from 'prop-types';


class Tree extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Tree';
    }
    componentDidMount() {
   	
    }
    componentDidUpdate(prevProps, prevState) {
          
    }
    render() {
        return <div className="tree">
        <ul><li>
        {this.props.children}
        </li></ul>
        </div>;
    }
}

Tree.propTypes = {

}

export default Tree;



// WEBPACK FOOTER //
// ./src/browser/components/ui/tree/tree.js